module.exports = __webpack_public_path__ + "img/special7.7d1eed88.png";